import { setcookieFunc } from "./useCookies";
// import GlobaleVar from "../config/globalVar";
import { login } from "../services/httpCalls";
import Cookies from "js-cookie";

function userInfo(userData){
  Cookies.set("userInfo",  JSON.stringify(userData))
}

export function LoginForm(userDet, redirectFunc, getLoginErrors) {
  login(userDet)
  .then((res) => {
    setcookieFunc(
      res?.accessToken,
      res?.refreshToken,
      userDet
    );
    
    if(res?.user){
        userInfo(res.user)
    }
  })
  .catch((error) => {
    getLoginErrors(error);
  })
  .finally(() => {
    setTimeout(() => {
      redirectFunc();
    },100)
  })
}
